import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useAggregateBalances = (
  businessId: string,
): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  return useQuery([ReactQueryKeys.AggregateBalances], async () => {
    const response = await treasureApi().get('business/aggregate_balances');

    return response.data;
  });
};
